import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
    {
        name: '8 am',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: '10am',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: '12pm',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: '2pm',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: '4pm',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: '6pm',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: '8pm',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

const DemandBarChart = () => {

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                width={500}
                height={380}
                data={data}
                margin={{
                    top: 20,
                    right: 0,
                    left: 0,
                    bottom: 0,
                }}
                barSize={40}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" fontSize={12} fill='#64748B' />
                <YAxis />
                <Tooltip />
                {/* <Legend /> */}
                <Bar dataKey="pv" fill="#8B6FA5" activeBar={<Rectangle fill="#8B6FA5" />} radius={[10, 10, 0, 0]} />
                <Bar dataKey="uv" fill="#E6D8F3" activeBar={<Rectangle fill="#E6D8F3" />} radius={[10, 10, 0, 0]} />
                <Bar dataKey="amt" fill="#BA9AD8" activeBar={<Rectangle fill="#BA9AD8" />} radius={[10, 10, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
    );
}

export default DemandBarChart;
